import React, {Component, Fragment} from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import XLSX from 'xlsx';

import './NonFederalFires.css';


class NonFederalRXFires extends Component {
  constructor(props) {

    super(props);

    const currentYear = new Date().getFullYear();
    const optionYears = Array.from(new Array(40), (val, index) => currentYear - index);

    this.state =
    {
      isQuerying: false,
      dataLoaded: false,
      dataResults: {},
      startYear: (currentYear - 5),
      endYear: currentYear,
      reportYears: this.getDates((currentYear - 5), currentYear),
      optionYears: optionYears,
      datesValid: true
    };
  }

  formatCsvData = () => {

    var years = [...this.state.reportYears];
    years.unshift('');

    let dataRows = [years];

    this.state.dataResults.forEach(dataRow => {
      const stateAbbr = dataRow.Key;
      let newRow = [stateAbbr]

      this.state.reportYears.forEach(year => {

        const dataObj = dataRow.Value[year];
        const displayValue = dataObj["RecordCount"];
        newRow.push(displayValue);
      });

      dataRows.push(newRow);
    });

    let summaryRow = ['Totals'];


    this.state.reportYears.forEach(year => {

      let yearTotal = 0;
      this.state.dataResults.forEach(dataRow => {

        const dataObj = dataRow.Value[year].RecordCount;
        yearTotal += dataObj;
      });

      summaryRow.push(yearTotal);
    });

    dataRows.push(summaryRow);
    return dataRows;
  }
  downloadCsv = () => {
    const workbook = XLSX.utils.book_new();
    let csvData = this.formatCsvData();
    let reportSheet = XLSX.utils.aoa_to_sheet(csvData);
    XLSX.utils.book_append_sheet(workbook, reportSheet, "NonFederalFires");

    XLSX.writeFile(workbook, "NonFederalFires.xlsx");
  }

  buildTable = () => {
    return (
      <Fragment>
        <Typography variant="h6" color="inherit">
          Number of Fires by State by Year
        </Typography>
        <Typography variant="subtitle1" color="inherit">
          as of {new Date().toUTCString()}
        </Typography>
        <Table>
          <TableHead>
            <TableRow key='yearRow'>
              <TableCell></TableCell>
              {
                this.state.reportYears.map(year => { return (<TableCell className="summaryCell" key={year}>{year}</TableCell>) })
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {this.getTableRows()}
            {this.getSummaryRow()}
          </TableBody>

        </Table>
      </Fragment>)
  }

  getSummaryRow = () => {

    let yearArray = [];
    this.state.reportYears.forEach(year => {
      let yearTotal = 0;

      this.state.dataResults.forEach(dataRow => {

        const dataObj = dataRow.Value[year].RecordCount;
        yearTotal += dataObj;
      });

      yearArray.push(yearTotal);
    });

    return (
      <TableRow>
        <TableCell className="summaryCell">Totals:</TableCell>
        {
          yearArray.map(year => {
            return (<TableCell className="summaryCell">{year}</TableCell>)
          })
        }
      </TableRow>
    )
  }

  getTableRows = () => {

    let index = 0;
    return this.state.dataResults.map(dataRow => {
      const stateAbbr = dataRow.Key
      index++;
      return (
        <TableRow key={stateAbbr} style={index % 2 ? { background: "#e2e2df" } : { background: "white" }}>
          <TableCell>{stateAbbr}</TableCell>
          {
            this.state.reportYears.map(year => {
              const dataObj = dataRow.Value[year];
              const displayValue = dataObj["RecordCount"];

              return (<TableCell>{displayValue}</TableCell>)
            })
          }
        </TableRow>
      )
    });

  }


  getDates = (startYear, endYear) => {

    var arr = [];
    var dt = startYear;

    while (dt <= endYear) {
      arr.push(dt);
      dt += 1;
    }

    return arr;
  };

  queryData = () => {
    if (!this.state.datesValid) {
      return;
    }
    this.setState({ isQuerying: true });

    window.api.queryNonFederalRXFiresForYear(this.state.startYear, this.state.endYear).then(
      result => {
        this.setState(
          {
            dataResults: JSON.parse(result),
            queryingComplete: true,
            dataLoaded: true
          });
      }
    )
  }

  render() {
    if (!this.props.visible) {
      return null;
    }

    if (!this.state.isQuerying && !this.state.dataLoaded) {
      this.queryData();
    }

    let tableHeader = (this.state.dataLoaded) ? this.buildTable() : (<div></div>);
    //
    return (this.props.visible) ? (
      <Paper>
        <div className="row">
          <div className="summaryColumn">
            <div>
              Start Year: <Select
                native
                value={this.state.startYear}
                onChange={(event) => {
                  const datesValid = (event.target.value <= this.state.endYear);

                  this.setState({
                    startYear: Number(event.target.value),
                    datesValid: datesValid,
                    reportYears: (datesValid) ? this.getDates(Number(event.target.value), this.state.endYear) : [],
                    dataLoaded: false,
                    isQuerying: false
                  });
                }}
              >
                {
                  this.state.optionYears.map(year => {
                    return (<option value={year}>{year}</option>)
                  }
                  )
                }
              </Select>

              End Year: <Select
                native
                value={this.state.endYear}
                onChange={(event) => {
                  const datesValid = (event.target.value >= this.state.startYear);

                  this.setState({
                    endYear: Number(event.target.value),
                    datesValid: datesValid,
                    reportYears: (datesValid) ? this.getDates(this.state.startYear, Number(event.target.value)) : [],
                    dataLoaded: false,
                    isQuerying: false
                  });
                }}
              >
                {
                  this.state.optionYears.map(year => {
                    return (<option value={year}>{year}</option>)
                  }
                  )
                }
              </Select>
            </div>
            {tableHeader}
          </div>
        </div>
      </Paper>
    ) : ('');
  }
}

export default NonFederalRXFires
